$('.accordion').click(function() {
    console.log('clicked');
    $(this).toggleClass('open');
    $(this).find('.accordion-body p').fadeToggle(400);
});


